export default {"src":"/_next/static/media/loader-black.f330d895.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};